// extracted by mini-css-extract-plugin
export default {"btnBlue":"fHqeXYsp","btnFull":"TSa4CVlq","high":"T2NyM0Va","disabled":"pnFIfguv","loading":"GaGu6DVp"};